import { LucideIcon } from 'lucide-react'
import Radio from '../radio/radio'
import { cn } from 'lib/util/cn'

const RadioButton = ({
  label,
  description,
  onClick,
  selected,
  Icon,
}: {
  label: string
  description: string
  onClick: () => void
  selected: boolean
  Icon: LucideIcon
}) => {
  return (
    <div
      className={cn(
        'transition-all duration-300 tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 tw-px-3 tw-py-2 hover:tw-border-cornflower-200 hover:tw-bg-cornflower-50',
        selected && 'tw-border-cornflower-300 tw-bg-cornflower-100',
      )}
      onClick={onClick}
    >
      <Radio checked={selected} readOnly />
      <Icon className="tw-min-h-4 tw-min-w-4" />
      <div className="tw-flex tw-flex-col">
        <div className="tw-text-sm tw-font-bold">{label}</div>
        <div className="tw-text-xs tw-text-neutral-500">{description}</div>
      </div>
    </div>
  )
}

export default RadioButton
